import { NgModule } from 'ng-metadata/core';
import { AlphabetStripModule } from './alphabet-strip/alphabet-strip.module';
import { SearchCountriesModule } from 'common/directory/countries/search-countries.module';
import { SearchLocationsModule } from 'common/directory/locations/search-locations.module';
import { SearchVaccinationsModule } from 'common/directory/vaccinations/search-vaccinations.module';
import { SearchVisaRequirementModule } from './visa-requirement/visa-requirement.module';

import './directory.scss';

@NgModule({
  imports: [
    AlphabetStripModule,
    SearchCountriesModule,
    SearchLocationsModule,
    SearchVaccinationsModule,
    SearchVisaRequirementModule,
  ],
})

export class DirectoryModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/directory.module.ts